<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content [innerHTML]="data.content" class="modal-body modal-content">
</div>
<div mat-dialog-actions class="modal-buttons">
  <button type="button" mat-raised-button class="mat-raised-button btn-red" (click)="cancel()">cancel</button>
  <button type="button" mat-raised-button class="mat-raised-button" (click)="noSave()">{{data.noSave}}</button>
  <button type="button" mat-raised-button class="mat-raised-button btn-green" (click)="save()">{{data.save}}</button>
</div>

